import React, { useCallback, useEffect, useTransition } from "react";
import {
  Flex,
  Row,
  Card,
  Typography,
  Col,
  Form,
  Input,
  Select,
  Button,
  Tooltip,
} from "antd";
import { colors } from "../../../../../../constants/colors";
import {
  AddLoginsIcon,
  AddPushNotificationIcon,
  AddSponsorshipsIcon,
} from "../../../../../../assets/svg";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import RequiredLabel from "../../../../../common/required-label/RequiredLabel";
import { allowCharactersOnlyForDecimalNumbers } from "../../../../../../utils/appKeyStrokeLimitingUtils";
import { useDispatch, useSelector } from "react-redux";
import {
  getOrganizationTopListingSubscriptionPlanAction,
  getSystemSettingsAction,
} from "../../../../../../redux/services/addon-and-sponsorship/addonAndSponsorshipServices";
import Actions from "../../../../../../redux/actions";
import {
  baseRouteMaker,
  routes,
} from "../../../../../../constants/routeConsts";
import { useNavigate } from "react-router-dom";
import { appConfig } from "../../../../../../constants/config/appConfig";
import useLocalStorage from "../../../../../../hooks/useLocalStorage";
import { getUserProfileAction } from "../../../../../../redux/services/auth/authServices";
import { checkSponsorshipAction } from "../../../../../../redux/services/common/commonServices";
import Spinner from "../../../../../common/spinner/Spinner";

const AddonsAndSponsorships = () => {
  /* i18n dependencies */
  const { t } = useTranslation();
  /* i18n dependencies */

  /* form dependencies */
  const [form] = Form.useForm();
  const [organizationForm] = Form.useForm();
  const [pushNotificationForm] = Form.useForm();
  /* form dependencies */

  /* dispatch dependencies */
  const dispatch = useDispatch();
  /* dispatch dependencies */

  /* navigation dependencies */
  const navigate = useNavigate();
  /* navigation dependencies */

  /* dialog dependencies */
  const [openAddLoginFormDialog, setOpenAddLoginFormDialog] = useState(false);
  const [, setOpenAddSponsorshipFormDialog] = useState(false);
  /* dialog dependencies */

  const { userSession, setUserSession } = useLocalStorage(
    appConfig.SESSION_USER_INFO
  );
  const { sponsorshipAvailability } = useSelector((state) => state?.common);
  const { loginDetails } = useSelector((state) => state?.auth);

  /* add login details */
  const handleAddLoginDetails = () => {
    setOpenAddLoginFormDialog(true);
  };
  /* add login details */

  /* add sponsorship details */
  const handleAddSponsorshipDetails = () => {
    setOpenAddSponsorshipFormDialog(true);
  };
  /* add sponsorship details */

  /* loading dependencies */
  const [loading, setLoading] = useState(false);
  const [selectListLoader] = useState(false);
  const [apiLoader, setApiLoader] = useState(false);
  /* loading dependencies */

  const { systemSettings, organizationTopListingSubscriptionPlans } =
    useSelector((state) => state.addonAndSponsorship);

  /* addon logins dependencies */
  const [selectedPeriod, setSelectedPeriod] = useState(null);
  /* addon logins dependencies */

  /* organization sponsorship dependencies */
  const [selectedPlan, setSelectedPlan] = useState(null);
  /* organization sponsorship dependencies */


  const handleGetTableData = async () => {
    const promiseArr = [
      dispatch(getSystemSettingsAction(setLoading)),
      dispatch(getOrganizationTopListingSubscriptionPlanAction({}, setLoading)),
      userSession &&
        Object.keys(userSession).length !== 0 &&
        userSession !== null &&
        userSession !== undefined &&
        dispatch(getUserProfileAction(setUserSession)).then((apiRes) => {
          const dataToBeSentForCheckSponsorship = {
            type: "organization",
            state: apiRes?.organization_id?.address?.state?.name,
            city: apiRes?.organization_id?.address?.city?.name,
          };
          dispatch(checkSponsorshipAction(dataToBeSentForCheckSponsorship, setLoading));
        }),
    ];

    try {
      setApiLoader(true);
      await Promise.all(promiseArr)
      setApiLoader(false);
    } catch (error) {
      setApiLoader(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  };

  useEffect(() => {
    handleGetTableData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /* on period changed for addon logins */
  const onPeriodChangedForAddonLogins = (id) => {
    const selectedPeriodObj = systemSettings?.addon_account_charges?.find(
      (element) => element._id === id
    );
    const tempSelectedPeriodObj = {
      ...selectedPeriodObj,
      currency: systemSettings?.system_currency,
    };
    setSelectedPeriod(tempSelectedPeriodObj);
    organizationForm.resetFields();
    setSelectedPlan(null);
  };
  /* on period changed for addon logins */

  /* on plan changed */
  const onPlanChanged = (id) => {
    const selectedPlanObj = organizationTopListingSubscriptionPlans?.find(
      (element) => element._id === id
    );
    setSelectedPlan(selectedPlanObj);
    form.resetFields();
    setSelectedPeriod(null);
  };
  /* on plan changed */

  /* on submit for addon logins */
  const onSubmit = (values) => {
    const { logins } = values;
    const price_based_on_logins =
      Number(selectedPeriod?.price) * Number(logins);
    const dataToBeSent = {
      type: "addon",
      event_type: "ADDON_LOGIN_PURCHASE",
      logins,
      addonLoginDurationAndPricingDetails: {
        ...selectedPeriod,
        price_based_on_logins,
      },
    };

    dispatch(
      Actions.createAction(Actions.SELECTED_ADDON_LOGIN_DETAILS, {
        selectedAddonLoginDetails: dataToBeSent,
      })
    );
    dispatch(Actions.createAction(Actions.CLEAR_COUPON));
    navigate(baseRouteMaker(routes.ADDON_LOGIN_PAYMENT));
  };
  /* on submit for addon logins */

  /* on submit for organization sponsorships */
  const onSubmitOrganizationForm = () => {
    const dataToBeSent = {
      ...selectedPlan,
      event_type: "SUBSCRIPTION",
      purchase_type: "organization",
    };

    dispatch(
      Actions.createAction(
        Actions.SELECTED_OFFERS_AND_PACKAGES_SPONSORSHIP_DETAILS,
        { selectedOffersAndPackagesSponsorshipDetails: dataToBeSent }
      )
    );
    dispatch(Actions.createAction(Actions.CLEAR_COUPON));
    navigate(baseRouteMaker(routes.OFFER_AND_PACKAGES_PAYMENT));
  };
  /* on submit for organization sponsorships */

  /* on submit for addon logins */
  const onSubmitForPushNotification = (values) => {
    const { push_notification } = values;
    const price_based_on_no_of_push_notification =
      Number(systemSettings?.single_push_notification_send_charges) *
      Number(push_notification);
    const dataToBeSent = {
      type: "push_notification",
      event_type: "PUSH_NOTIFICATION_PURCHASE",
      push_notification: Number(push_notification),
      pushNotificationDurationAndPricingDetails: {
        currency: systemSettings?.system_currency,
        price_based_on_no_of_push_notification,
      },
    };

    dispatch(
      Actions.createAction(Actions.SELECTED_PUSH_NOTIFICATION_DETAILS, {
        selectedPushNotificationDetails: dataToBeSent,
      })
    );
    dispatch(Actions.createAction(Actions.CLEAR_COUPON));
    navigate(baseRouteMaker(routes.PUSH_NOTIFICATION_PAYMENT));
  };
  /* on submit for addon logins */

  const GetSponsorshipAvailabilityLayout = ({
    children,
    availability,
    topListingEnabled,
    noSponsorshipTitle,
    alreadySponsoredTitle
  }) => {
    return (
      <>
          <Tooltip
            placement="topLeft"
            title={topListingEnabled ? alreadySponsoredTitle : (!topListingEnabled && !availability) ? noSponsorshipTitle : ""}
            color={colors.limeGreen}
            destroyTooltipOnHide
            autoAdjustOverflow
          >
            {children}
          </Tooltip>
      </>
    );
  };

  // const GetAddonAvailabilityLayout = React.memo(({ children, isFreePlan }) => {
  //   return (
  //     <>
  //       <Tooltip
  //         placement="topLeft"
  //         title={isFreePlan ? t("CommonUtils.upgradeYourSubscription") : ""}
  //         color={colors.limeGreen}
  //         destroyTooltipOnHide
  //         autoAdjustOverflow
  //       >
  //         {children}
  //       </Tooltip>
  //     </>
  //   );
  // });

  const GetAvailabilityForPremiumFeatures = React.memo(
    ({ children, isFreePlan }) => {
      return (
        <>
          <Tooltip
            placement="topLeft"
            title={isFreePlan ? t("CommonUtils.upgradeYourSubscription") : ""}
            color={colors.limeGreen}
            destroyTooltipOnHide
            autoAdjustOverflow
          >
            {children}
          </Tooltip>
        </>
      );
    }
  );



  return apiLoader ? (
    <Spinner />
  ) : (
    <Flex justify="center" gap="2rem">
      <GetAvailabilityForPremiumFeatures
        isFreePlan={
          loginDetails?.organization_id?.current_plan_id?.code === "FREE"
        }
      >
        <Flex justify="center" gap="2rem">
          <div
            style={{
              width: 300,
              height: 500,
              boxShadow: "1px 4px 8px rgba(0,0,0,0.1)",
              background: "white",
              border: `1px solid ${colors.limeGreen}`,
              display: "flex",
              justifyContent: "space-between",
              flexDirection: "column",
              padding: 20,
              borderRadius: 20,
            }}
            onClick={(e) => handleAddLoginDetails(e, null)}
          >
            <Flex vertical gap="1rem" justify="center" align="center">
              <AddLoginsIcon fillColor={colors.primaryColor} />
              <Typography.Title level={4}>
                {t("Modules.addOns.addLogins")}
              </Typography.Title>
            </Flex>
            <Form
              style={{
                marginTop: 20,
                height: "100%",
                display: "flex",
                justifyContent: "space-between",
                flexDirection: "column",
              }}
              form={form}
              layout="vertical"
              autoComplete="off"
              requiredMark={false}
              onFinish={onSubmit}
            >
              <div>
                <Form.Item
                  label={
                    <RequiredLabel
                      text={t("Modules.AddLoginsAndSponsorships.users")}
                      required={true}
                    />
                  }
                  name="logins"
                  rules={[
                    {
                      required: true,
                      message: t(
                        "Modules.AddLoginsAndSponsorships.pleaseEnterUsers"
                      ),
                    },
                    {
                      validator: (_, value) => {
                        if (value && value < 1)
                          return Promise.reject(
                            `${t("Modules.AddLoginsAndSponsorships.users")} ${t(
                              "CommonUtils.shouldBeGreaterThan0"
                            )}`
                          );
                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <Input
                    type="number"
                    placeholder={t(
                      "Modules.AddLoginsAndSponsorships.enterUsers"
                    )}
                    onKeyDown={(e) => {
                      allowCharactersOnlyForDecimalNumbers(e);
                      organizationForm.resetFields();
                      setSelectedPlan(null);
                    }}
                    disabled={
                      loginDetails?.organization_id?.current_plan_id?.code ===
                      "FREE"
                    }
                  />
                </Form.Item>

                <Form.Item
                  name="duration"
                  label={
                    <RequiredLabel
                      text={t("Modules.Ads.period")}
                      required={true}
                    />
                  }
                  rules={[
                    {
                      required: true,
                      message: t("Modules.Ads.pleaseSelectPeriod"),
                    },
                  ]}
                >
                  <Select
                    loading={selectListLoader}
                    options={systemSettings?.addon_account_charges?.map(
                      (element) => ({
                        value: element._id,
                        label: `${element.duration} month${
                          element.duration > 1 ? "s" : ""
                        }`,
                        price: `${element.price} ${element.currency}`,
                        currency: systemSettings?.system_currency,
                      })
                    )}
                    onChange={(value) => onPeriodChangedForAddonLogins(value)}
                    placeholder={t("Modules.Ads.selectPeriod")}
                    disabled={
                      loginDetails?.organization_id?.current_plan_id?.code ===
                      "FREE"
                    }
                  />
                </Form.Item>
                {selectedPeriod &&
                  selectedPeriod !== null &&
                  selectedPeriod !== undefined && (
                    <Flex gap="0.8rem">
                      <Flex gap="0.8rem" align="center" justify="center">
                        <Typography.Title
                          level={2}
                          style={{
                            color: colors.royalPurple,
                            margin: 0,
                          }}
                        >
                          {selectedPeriod
                            ? `${selectedPeriod?.price} ${selectedPeriod?.currency}`
                            : ""}
                        </Typography.Title>
                        <Typography.Title
                          level={2}
                          style={{
                            color: colors.royalPurple,
                            margin: 0,
                          }}
                        >
                          / {t("CommonUtils.each")}
                        </Typography.Title>
                      </Flex>

                      {Number(selectedPeriod?.duration) !== 1 && (
                        <Typography.Title
                          level={5}
                          style={{
                            color: colors.royalPurple,
                            margin: 0,
                            textDecoration: "line-through",
                          }}
                        >
                          {selectedPeriod
                            ? `${
                                selectedPeriod?.duration *
                                (systemSettings?.addon_account_charges?.find(
                                  (element) => Number(element.duration) === 1
                                )?.price || 50)
                              } ${selectedPeriod?.currency}`
                            : ""}
                        </Typography.Title>
                      )}
                    </Flex>
                  )}
              </div>
              <Button
                type="primary"
                htmlType="submit"
                loading={apiLoader}
                disabled={
                  apiLoader ||
                  loginDetails?.organization_id?.current_plan_id?.code ===
                    "FREE"
                }
                style={{ width: "100%", marginTop: "1rem" }}
              >
                {t("CommonUtils.purchase")}
              </Button>
            </Form>
          </div>

          <GetSponsorshipAvailabilityLayout
            topListingEnabled={
              loginDetails?.organization_id?.top_listing_enabled
            }
            availability={sponsorshipAvailability?.sposorship_available}
            noSponsorshipTitle={t("CommonUtils.noSponsorshipsAvailable")}
            alreadySponsoredTitle={t("CommonUtils.alreadySponsored")}
          >
            <div
              style={{
                width: 300,
                height: 500,
                boxShadow: "1px 4px 8px rgba(0,0,0,0.1)",
                background: "white",
                border: `1px solid ${colors.limeGreen}`,
                display: "flex",

                flexDirection: "column",
                padding: 20,
                borderRadius: 20,
              }}
              onClick={(e) => handleAddSponsorshipDetails(e, null)}
            >
              <Flex vertical gap="1rem" justify="center" align="center">
                <AddSponsorshipsIcon fillColor={colors.primaryColor} />
                <Typography.Title level={4}>
                  {t("Modules.addOns.addOnSponsorships")}
                </Typography.Title>
              </Flex>
              <Form
                style={{
                  marginTop: 20,
                  height: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                  flexDirection: "column",
                }}
                form={organizationForm}
                layout="vertical"
                autoComplete="off"
                requiredMark={false}
                onFinish={onSubmitOrganizationForm}
              >
                <div>
                  <Form.Item
                    name="plan"
                    label={
                      <RequiredLabel
                        text={t("Modules.Ads.plan")}
                        required={true}
                      />
                    }
                    rules={[
                      {
                        required: true,
                        message: t("Modules.Ads.pleaseSelectPlan"),
                      },
                    ]}
                  >
                    <Select
                      loading={selectListLoader}
                      options={organizationTopListingSubscriptionPlans}
                      onChange={(value) => onPlanChanged(value)}
                      placeholder={t("Modules.Ads.selectPlan")}
                      disabled={
                        !sponsorshipAvailability?.sposorship_available ||
                        loginDetails?.organization_id?.current_plan_id?.code ===
                          "FREE" ||
                        loginDetails?.organization_id?.top_listing_enabled
                      }
                      defaultValue={
                        loginDetails?.organization_id
                          ?.top_listing_current_plan_id
                      }
                    />
                  </Form.Item>
                  {selectedPlan &&
                    selectedPlan !== null &&
                    selectedPlan !== undefined && (
                      <Flex gap="0.8rem">
                        <Typography.Title
                          level={2}
                          style={{
                            color: colors.royalPurple,
                            margin: 0,
                          }}
                        >
                          {selectedPlan
                            ? `${selectedPlan?.price} ${selectedPlan?.currency} for ${selectedPlan?.duration} ${selectedPlan?.duration_unit}`
                            : ""}
                        </Typography.Title>
                      </Flex>
                    )}
                </div>
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={apiLoader}
                  disabled={
                    apiLoader ||
                    !sponsorshipAvailability?.sposorship_available ||
                    loginDetails?.organization_id?.current_plan_id?.code ===
                      "FREE" ||
                    loginDetails?.organization_id?.top_listing_enabled
                  }
                  style={{ width: "100%", marginTop: "1rem" }}
                >
                  {t("CommonUtils.purchase")}
                </Button>
              </Form>
            </div>
          </GetSponsorshipAvailabilityLayout>

          <div
            style={{
              width: 300,
              height: 500,
              boxShadow: "1px 4px 8px rgba(0,0,0,0.1)",
              background: "white",
              border: `1px solid ${colors.limeGreen}`,
              display: "flex",
              justifyContent: "space-between",
              flexDirection: "column",
              padding: 20,
              borderRadius: 20,
            }}
            onClick={(e) => handleAddLoginDetails(e, null)}
          >
            <Flex vertical gap="1rem" justify="center" align="center">
              <AddPushNotificationIcon fillColor={colors.primaryColor} />
              <Typography.Title level={4}>
                {t("Modules.addOns.addPushNotification")}
              </Typography.Title>
            </Flex>
            <Form
              style={{
                marginTop: 20,
                height: "100%",
                display: "flex",
                justifyContent: "space-between",
                flexDirection: "column",
              }}
              form={pushNotificationForm}
              layout="vertical"
              autoComplete="off"
              requiredMark={false}
              onFinish={onSubmitForPushNotification}
            >
              <div>
                <Form.Item
                  label={
                    <RequiredLabel
                      text={t("Modules.addOns.noOfPushNotification")}
                      required={true}
                    />
                  }
                  name="push_notification"
                  rules={[
                    {
                      required: true,
                      message: t(
                        "Modules.addOns.pleaseEnterNoOfPushNotification"
                      ),
                    },
                    {
                      validator: (_, value) => {
                        if (value && value < 1)
                          return Promise.reject(
                            `${t(
                              "Modules.addOns.pleaseEnterNoOfPushNotification"
                            )} ${t("CommonUtils.shouldBeGreaterThan0")}`
                          );
                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <Input
                    type="number"
                    placeholder={t("Modules.addOns.enterNoOfPushNotification")}
                    onKeyDown={(e) => {
                      allowCharactersOnlyForDecimalNumbers(e);
                      organizationForm.resetFields();
                      setSelectedPlan(null);
                    }}
                    disabled={
                      loginDetails?.organization_id?.current_plan_id?.code ===
                      "FREE"
                    }
                  />
                </Form.Item>

                {systemSettings &&
                  systemSettings !== null &&
                  systemSettings !== undefined && (
                    <Flex gap="0.8rem">
                      <Flex gap="0.8rem" align="center" justify="center">
                        <Typography.Title
                          level={2}
                          style={{
                            color: colors.royalPurple,
                            margin: 0,
                          }}
                        >
                          {systemSettings?.single_push_notification_send_charges
                            ? `${systemSettings?.single_push_notification_send_charges} ${systemSettings?.system_currency}`
                            : ""}
                        </Typography.Title>
                        <Typography.Title
                          level={2}
                          style={{
                            color: colors.royalPurple,
                            margin: 0,
                          }}
                        >
                          / {t("CommonUtils.each")}
                        </Typography.Title>
                      </Flex>
                    </Flex>
                  )}
              </div>
              <Button
                type="primary"
                htmlType="submit"
                loading={apiLoader}
                disabled={
                  apiLoader ||
                  loginDetails?.organization_id?.current_plan_id?.code ===
                    "FREE"
                }
                style={{ width: "100%", marginTop: "1rem" }}
              >
                {t("CommonUtils.purchase")}
              </Button>
            </Form>
          </div>
        </Flex>
      </GetAvailabilityForPremiumFeatures>
    </Flex>
  );
};

export default React.memo(AddonsAndSponsorships);
